(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3677],{

/***/ 37677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const { default: Image  } = __webpack_require__(25675);
const { useState  } = __webpack_require__(67294);
const PhotoBox = (param)=>{
    let { src , width , height , alt , bro , ...props } = param;
    const [isShow, setIsShow] = useState(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isShow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                    src: src,
                    width: width,
                    height: height,
                    alt: alt,
                    onError: ()=>setIsShow(false),
                    ...props
                }),
                bro
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhotoBox);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 23677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Photos; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82017);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86010);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86886);
/* harmony import */ var _mui_base_ModalUnstyled__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(53407);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90948);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1954);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15378);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(30568);
/* harmony import */ var src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37677);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34745);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95629);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97937);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26346);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61011);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(3089);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(64789);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50607);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _RangePickerBox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15171);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99443);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74743);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  width: 100%;\n  z-index: 1300;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: -1;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-tap-highlight-color: transparent;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






















const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
const BackdropUnstyled = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((props, ref)=>{
    const { open , className , ...other } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
            "MuiBackdrop-open": open
        }, className),
        ref: ref,
        ...other
    });
});
BackdropUnstyled.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().string.isRequired),
    open: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().bool)
};
const Modal = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_mui_base_ModalUnstyled__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_templateObject());
const Backdrop = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(BackdropUnstyled)(_templateObject1());
const RegisterIllustration = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)("img")((param)=>{
    let { theme  } = param;
    return {
        [theme.breakpoints.down("lg")]: {
            height: "80%",
            width: "calc(100vw-80px)"
        }
    };
});
function formateSeconds(endTime) {
    let secondTime = parseInt(endTime) //将传入的秒的值转化为Number
    ;
    let min = 0 // 初始化分
    ;
    let h = 0 // 初始化小时
    ;
    let result = "";
    if (secondTime > 60) {
        min = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (min > 60) {
            h = parseInt(min / 60);
            min = parseInt(min % 60);
        }
    }
    result = "".concat(min.toString().padStart(2, "0"), ":").concat(secondTime.toString().padStart(2, "0"));
    return result;
}
function Photos(param) {
    let { type  } = param;
    // 状态管理
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_12__/* .useDispatch */ .I0)();
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_12__/* .useSelector */ .v9)((state)=>state.Photo);
    // 文件夹
    const [albumSummary, setAlbumSummary] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const photosPaseUrl = "https://cos.spyx.com/";
    const noPhotoUrl = "/images/photos/no-photo.png";
    const getCosUrl = (path)=>path ? photosPaseUrl + path : noPhotoUrl;
    const getAlbumCoverUrl = (item)=>{
        var ref, ref1;
        if (item.amount == 0) return noPhotoUrl;
        const path = ((ref = item.cover) === null || ref === void 0 ? void 0 : ref.url) || item.url || ((ref1 = item.thumb) === null || ref1 === void 0 ? void 0 : ref1.url);
        return getCosUrl(path);
    };
    // 目录层级
    const [level, setLevel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 所有选中数据
    const [allData, setAllData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    // 选中数据
    const [selectedData, setSelectedData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    // 日期筛选区间（antd RangePicker 的值）
    const [antdSelectedDates, setAntdSelectedDates] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    // 预览图片
    const [photodata, setPhotoData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    // 模态框
    const [open, setOpen] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    const MIN_PHOTO_ZOOM = 1;
    const MAX_PHOTO_ZOOM = 5;
    const PHOTO_ZOOM_STEP = 0.25;
    const [photoZoom, setPhotoZoom] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1);
    const [panOffset, setPanOffset] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        x: 0,
        y: 0
    });
    const [isPhotoDragging, setIsPhotoDragging] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const panDragRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({
        active: false,
        lastX: 0,
        lastY: 0
    });
    const photoPreviewRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const photoStageRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const photoZoomRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(1);
    // 只存储图片数据
    const [useImages, setImages] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) //正在加载获取数据
    ;
    const [loadError, setLoadError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    let { data: userData  } = JSON.parse(localStorage.getItem("userData"));
    /** 每次请求时现读 DeviceUser，避免闭包里的旧设备 */ const readPhotoDeviceUser = ()=>{
        var ref;
        return ((ref = JSON.parse(localStorage.getItem("DeviceUser") || "{}")) === null || ref === void 0 ? void 0 : ref.username) || "";
    };
    // 设备切换时重拉相册摘要；详情分页由 Photo slice + deviceSwitched 重置
    const loadAlbumSummary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(async function(_) {
        let { signal , isCurrent  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .removeNowName */ .lV)());
        const getDeviceUser = readPhotoDeviceUser();
        setIsLoading(true);
        setLoadError(false);
        setAlbumSummary([]);
        setSelectedData([]);
        setAllData([]);
        setLevel(0);
        const setAlbumSummaryData = async (data)=>{
            let response;
            // 相册摘要只等待 30 秒；超时后退出加载态并提供重试，避免页面长期停留在 Loading。
            const requestOpts = signal ? {
                signal,
                timeout: 30000
            } : {
                timeout: 30000
            };
            if (type === "android-local") {
                response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getLocalAndroidAll */ .gH)(data, requestOpts);
            } else if (type === "google-cloud") {
                response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getGcloudAll */ .U1)(data, requestOpts);
            } else {
                response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAlbumSummary */ .A0)(data, requestOpts);
            }
            if (isCurrent && !isCurrent()) return;
            setIsLoading(false);
            if (response.data.contents != null) {
                let result = response.data.contents.map((item)=>{
                    return {
                        ...item,
                        url: getAlbumCoverUrl(item)
                    };
                });
                const res = result.filter((item)=>{
                    const _name = item.album || item.name;
                    return !_name.includes("Videos");
                });
                setLevel(0);
                setAlbumSummary(res);
            }
        };
        try {
            if (type === "android-local") {
                await setAlbumSummaryData({
                    username: userData.email,
                    params: {
                        category: "ALBUM_SUMMARY",
                        deviceUdid: getDeviceUser,
                        offset: 0,
                        limit: 9999
                    }
                });
            } else if (type === "google-cloud") {
                await setAlbumSummaryData({
                    username: getDeviceUser,
                    params: {
                        category: "ALBUM_SUMMARY"
                    }
                });
            } else {
                await setAlbumSummaryData({
                    username: getDeviceUser,
                    params: {
                        category: "ALBUM_SUMMARY"
                    }
                });
            }
        } catch (err) {
            if (isCurrent && !isCurrent()) return;
            if ((err === null || err === void 0 ? void 0 : err.code) === "ERR_CANCELED") return;
            setAlbumSummary([]);
            setLoadError(true);
            setIsLoading(false);
        }
    }, [
        type,
        userData.email,
        dispatch
    ]);
    // 设备切换时重新拉相册摘要
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceScopedInit */ .A)(loadAlbumSummary);
    // 单文件夹ref
    const foldersRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // 滚动每次查询数量
    const reqNum = 50;
    // 存放滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    // 存放当前相册文件夹信息
    const [rowData, setrowData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    // 监听进度条滚动
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (foldersRef.current) {
                const { scrollTop , scrollHeight , clientHeight  } = foldersRef.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = foldersRef.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handleScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handleScroll);
            }
        };
    }, [
        level
    ]);
    // 监听滚动百分比查询下一页数据
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (scroll >= 100) {
            const row = rowData;
            // 查询下一页数据
            if (!store.isLoading) {
                dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .fetchPhotoData */ .OX)({
                    type,
                    row,
                    reqNum,
                    getDeviceUser: readPhotoDeviceUser(),
                    userData
                }));
            }
        }
    }, [
        scroll
    ]);
    // 客户端兜底筛选：接口已按日期过滤时是空操作；若接口不支持时间参数，也能筛已加载的数据
    const filterByRange = (list)=>{
        if (!antdSelectedDates || antdSelectedDates.length !== 2) return list;
        const startTime = dayjs__WEBPACK_IMPORTED_MODULE_10___default()(antdSelectedDates[0]).startOf("day").valueOf();
        const endTime = dayjs__WEBPACK_IMPORTED_MODULE_10___default()(antdSelectedDates[1]).endOf("day").valueOf();
        return list.filter((item)=>{
            let itemTime = NaN;
            if (item.created) itemTime = dayjs__WEBPACK_IMPORTED_MODULE_10___default()(item.created).valueOf();
            else if (item.date) itemTime = Number(item.date) * 1000;
            return itemTime >= startTime && itemTime <= endTime;
        });
    };
    // 状态变化时更新数据
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setLevel(store.level);
        if (store.selectedData.length > 0 && store.allData.length > 0) {
            const data = store.selectedData.find((item)=>item.name === store.nowName);
            const allData = store.allData.find((item)=>item.name === store.nowName);
            const imgs = store.useImages.find((item)=>item.name === store.nowName);
            setSelectedData(filterByRange(data ? data.list : []));
            setAllData(filterByRange(allData ? allData.list : []));
            setImages(filterByRange(imgs ? imgs.list : []));
        }
    }, [
        store,
        antdSelectedDates
    ]);
    // 打开模态框
    const handleOpen = ()=>{
        photoZoomRef.current = 1;
        setPhotoZoom(1);
        setPanOffset({
            x: 0,
            y: 0
        });
        setOpen(true);
    };
    // 关闭
    const handleClose = ()=>{
        setOpen(false);
        photoZoomRef.current = 1;
        setPhotoZoom(1);
        setPanOffset({
            x: 0,
            y: 0
        });
    };
    const openSetPhotoData = (result)=>{
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium,
                ...result
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original,
                ...result
            });
        }
    };
    const resetPhotoView = ()=>{
        photoZoomRef.current = 1;
        setPhotoZoom(1);
        setPanOffset({
            x: 0,
            y: 0
        });
        setIsPhotoDragging(false);
    };
    // 上一个图片
    const previousPhotos = ()=>{
        let index = useImages.findIndex((item)=>{
            return item.id == photodata.id;
        });
        let result = useImages[index - 1];
        if (typeof result === "undefined") return;
        resetPhotoView();
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium,
                ...result
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original,
                ...result
            });
        }
    };
    //  下一个图片
    const nextPhotos = ()=>{
        let index = useImages.findIndex((item)=>{
            return item.id == photodata.id;
        });
        let result = useImages[index + 1];
        if (typeof result === "undefined") return;
        resetPhotoView();
        if (JSON.stringify(result.medium) != "{}") {
            setPhotoData({
                id: result.id,
                ...result.medium,
                ...result
            });
        } else {
            setPhotoData({
                id: result.id,
                ...result.original,
                ...result
            });
        }
    };
    const clampPhotoZoom = (value)=>Math.min(MAX_PHOTO_ZOOM, Math.max(MIN_PHOTO_ZOOM, Number(value.toFixed(2))));
    const clampPanOffset = function(offset) {
        let zoom = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : photoZoomRef.current;
        const stage = photoStageRef.current;
        const img = photoPreviewRef.current;
        if (!stage || !img || zoom <= 1) return {
            x: 0,
            y: 0
        };
        const baseW = img.offsetWidth;
        const baseH = img.offsetHeight;
        if (!baseW || !baseH) return {
            x: 0,
            y: 0
        };
        const maxX = Math.max(0, (baseW * zoom - stage.clientWidth) / 2);
        const maxY = Math.max(0, (baseH * zoom - stage.clientHeight) / 2);
        return {
            x: Math.min(maxX, Math.max(-maxX, offset.x)),
            y: Math.min(maxY, Math.max(-maxY, offset.y))
        };
    };
    const applyPhotoZoom = (nextZoom)=>{
        const zoom = clampPhotoZoom(nextZoom);
        photoZoomRef.current = zoom;
        setPhotoZoom(zoom);
        setPanOffset((prev)=>clampPanOffset(prev, zoom));
    };
    const zoomInPhoto = (e)=>{
        e.stopPropagation();
        applyPhotoZoom(photoZoomRef.current + PHOTO_ZOOM_STEP);
    };
    const zoomOutPhoto = (e)=>{
        e.stopPropagation();
        applyPhotoZoom(photoZoomRef.current - PHOTO_ZOOM_STEP);
    };
    const onPhotoZoomSliderChange = (value)=>{
        applyPhotoZoom(value / 100);
    };
    const onPhotoPointerDown = (e)=>{
        var _currentTarget, ref;
        if (photoZoomRef.current <= 1) return;
        e.stopPropagation();
        panDragRef.current = {
            active: true,
            lastX: e.clientX,
            lastY: e.clientY
        };
        setIsPhotoDragging(true);
        (ref = (_currentTarget = e.currentTarget).setPointerCapture) === null || ref === void 0 ? void 0 : ref.call(_currentTarget, e.pointerId);
    };
    const onPhotoPointerMove = (e)=>{
        if (!panDragRef.current.active) return;
        e.stopPropagation();
        const dx = e.clientX - panDragRef.current.lastX;
        const dy = e.clientY - panDragRef.current.lastY;
        panDragRef.current.lastX = e.clientX;
        panDragRef.current.lastY = e.clientY;
        setPanOffset((prev)=>clampPanOffset({
                x: prev.x + dx,
                y: prev.y + dy
            }, photoZoomRef.current));
    };
    const onPhotoPointerUp = (e)=>{
        var _currentTarget, ref;
        if (!panDragRef.current.active) return;
        panDragRef.current.active = false;
        setIsPhotoDragging(false);
        (ref = (_currentTarget = e.currentTarget).releasePointerCapture) === null || ref === void 0 ? void 0 : ref.call(_currentTarget, e.pointerId);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        photoZoomRef.current = photoZoom;
    }, [
        photoZoom
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const stage = photoStageRef.current;
        if (!open || !stage) return undefined;
        const onWheel = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const delta = event.deltaY > 0 ? -0.15 : 0.15;
            applyPhotoZoom(photoZoomRef.current + delta);
        };
        const onResize = ()=>{
            setPanOffset((prev)=>clampPanOffset(prev, photoZoomRef.current));
        };
        stage.addEventListener("wheel", onWheel, {
            passive: false
        });
        window.addEventListener("resize", onResize);
        return ()=>{
            stage.removeEventListener("wheel", onWheel);
            window.removeEventListener("resize", onResize);
        };
    }, [
        open
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!open) return;
        setPanOffset((prev)=>clampPanOffset(prev, photoZoomRef.current));
    }, [
        open,
        photodata.id,
        photoZoom
    ]);
    // 返回目录
    const goBack = ()=>{
        // 清空上次打开文件名名称
        dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .removeNowName */ .lV)());
    };
    const [currentVideo, setCurrentVideo] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    // 播放视频模态框
    const [videoModalOpen, setVideoModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    // 关闭视频模态框
    const cancelVideoModalOpen = ()=>{
        setVideoModalOpen(false);
        setCurrentVideo({});
    };
    // 当前视频对象
    const playVideo = (row)=>{
        setVideoModalOpen(true);
        setCurrentVideo(row);
    };
    //选择日期范围：交给接口按日期重新取数（列表渲染仍会做一次客户端兜底筛选）
    const handleDateChange = (dates)=>{
        const picked = dates && dates.length === 2 ? dates : [];
        setAntdSelectedDates(picked);
        dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .setPhotoDateRange */ .Gt)(picked.length === 2 ? picked : null));
        const row = rowData;
        if (row) {
            if (foldersRef.current) foldersRef.current.scrollTop = 0;
            setScroll(0);
            dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .fetchPhotoData */ .OX)({
                type,
                row,
                reqNum,
                getDeviceUser: readPhotoDeviceUser(),
                userData
            }));
        }
    };
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const title = t("Photo");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            level == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] Bxl:h-[calc(var(--vh2)*100-90px)] pt-[20px] px-[15px] pb-[21px] overflow-auto relative",
                children: [
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                    }) : loadError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px] flex flex-col items-center justify-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "text-[14px] text-[#626262]",
                                children: "Photos could not be loaded."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                className: "px-[20px] py-[8px] rounded-[18px] bg-[#12D8AB] text-[#07273D] font-[600]",
                                onClick: ()=>loadAlbumSummary(),
                                children: "Try again"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            container: true,
                            spacing: 1.5,
                            children: albumSummary.map((row)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 4,
                                    md: 3,
                                    lg: 2,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex flex-col justify-center items-center cursor-pointer",
                                        onClick: ()=>{
                                            // 存储当前点击文件夹信息
                                            setrowData(row);
                                            const albumKey = (0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .getAlbumKey */ ._c)(row);
                                            const nowData = Array.from(store.allData).find((item)=>item.name === albumKey);
                                            // 每次点击文件夹时，未查询过数据或数据为空再发送请求
                                            if (nowData === undefined || nowData.list.length === 0) {
                                                dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .fetchPhotoData */ .OX)({
                                                    type,
                                                    row,
                                                    reqNum,
                                                    getDeviceUser: readPhotoDeviceUser(),
                                                    userData
                                                }));
                                            } else {
                                                const data = store.selectedData.find((item)=>item.name === nowData.name);
                                                const allData = store.allData.find((item)=>item.name === nowData.name);
                                                const imgs = store.useImages.find((item)=>item.name === nowData.name);
                                                setSelectedData(data ? data.list : []);
                                                setAllData(allData ? allData.list : []);
                                                setImages(imgs ? imgs.list : []);
                                                setLevel(1);
                                                const fileRid = nowData.name;
                                                const level = 1;
                                                const nowName = nowData.name;
                                                dispatch((0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .resetNowName */ .YJ)({
                                                    fileRid,
                                                    level,
                                                    nowName
                                                }));
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                src: row.url,
                                                width: 0,
                                                height: 0,
                                                alt: row.album,
                                                className: "rounded-[4px] w-[95px] h-[95px]",
                                                onError: (e)=>{
                                                    e.target.src = "/images/photos/no-photo.png";
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "w-[95px] flex justify-start text-[14px] text-[#000000] mt-[8px] break-all",
                                                children: row.album || row.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "w-[95px] flex justify-start text-[14px] text-[#8A8A8D]",
                                                children: row.amount
                                            })
                                        ]
                                    })
                                }, (0,src_store_apps_photo__WEBPACK_IMPORTED_MODULE_13__/* .getAlbumKey */ ._c)(row)))
                        })
                    }),
                    albumSummary.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                        children: [
                            t("It appears theres no data to show here yet"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("If data exists it may take up to 1 hour to download and appear"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("We suggest checking back in a little while")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {}),
            level == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] Bxl:h-[calc(var(--vh2)*100-90px)] flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "w-full h-[44px] flex justify-between items-center px-[14px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: "/images/photos/return.svg",
                                width: 20,
                                height: 20,
                                alt: "return",
                                onClick: goBack,
                                className: "cursor-pointer"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                className: "text-[16px] text-[#000] font-[600]",
                                children: store.fileRid
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "w-[20px] h-[20px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "w-full px-[12px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_RangePickerBox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            value: antdSelectedDates,
                            onChange: handleDateChange,
                            onClear: ()=>{
                                setAntdSelectedDates([]);
                                handleDateChange([]);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        ref: foldersRef,
                        className: "flex-1 overflow-auto pb-[5px] rounded-[0_0_10px_10px] py-[12px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "w-full grid gap-x-[9px] gap-y-[11px] sm:gap-x-1 grid-cols-2 Sixmds:grid-cols-4 Blds:grid-cols-6 ",
                            children: selectedData.map((item)=>{
                                if (item.type === "mp4") {
                                    if (type !== "android-local") return null;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                type: "button",
                                                disabled: !item.original_url,
                                                "aria-label": "Play ".concat(item.filename || "video"),
                                                className: "relative w-full aspect-square flex items-center justify-center overflow-hidden rounded-lg ".concat(item.original_url ? "cursor-pointer" : "cursor-default"),
                                                onClick: ()=>playVideo(item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        className: "max-h-full max-w-full object-contain",
                                                        src: getCosUrl(item.cover_url),
                                                        alt: item.filename || "video",
                                                        width: 300,
                                                        height: 300
                                                    }),
                                                    item.original_url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        src: "/images/photos/play.png",
                                                        width: 30,
                                                        height: 30,
                                                        alt: "",
                                                        className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                                                    }),
                                                    item.cover_duration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "absolute bottom-1 right-1 rounded bg-[rgba(0,0,0,0.6)] px-1 text-[12px] text-white",
                                                        children: item.cover_duration
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "w-full text-[12px] pt-[8px] pl-1 text-[#000]",
                                                children: [
                                                    item.created && dayjs__WEBPACK_IMPORTED_MODULE_10___default()(item.created).format("YYYY/MM/DD HH:mm"),
                                                    item.date && dayjs__WEBPACK_IMPORTED_MODULE_10___default().unix(item.date).format("YYYY/MM/DD HH:mm")
                                                ]
                                            })
                                        ]
                                    }, item.id);
                                }
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        onClick: handleOpen,
                                        className: "cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "w-full aspect-square flex items-center justify-center overflow-hidden rounded-lg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_photos_PhotoBox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    className: "max-h-full max-w-full object-contain",
                                                    src: getCosUrl(item.thumb_url),
                                                    onClick: ()=>openSetPhotoData(item),
                                                    alt: item.filename,
                                                    width: 300,
                                                    height: 300
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "w-full text-[12px] pt-[8px] pl-1 text-[#000]",
                                                children: [
                                                    item.created && dayjs__WEBPACK_IMPORTED_MODULE_10___default()(item.created).format("YYYY/MM/DD HH:mm"),
                                                    item.date && dayjs__WEBPACK_IMPORTED_MODULE_10___default().unix(item.date).format("YYYY/MM/DD HH:mm")
                                                ]
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        })
                    }),
                    open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        transition: {
                            duration: 0.2
                        },
                        className: "absolute inset-0 z-[1] overflow-hidden select-none bg-[rgba(0,0,0,0.5)]",
                        onClick: handleClose,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                className: "absolute right-4 top-4 z-[5] cursor-pointer text-[28px] text-[#FFF] pointer-events-auto smj:right-3 smj:top-3 smj:text-[22px]",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleClose();
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                className: "absolute left-2 top-1/2 z-[5] -translate-y-1/2 cursor-pointer text-[40px] text-[#FFF] pointer-events-auto smj:left-1 smj:text-[32px]",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    previousPhotos();
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                className: "absolute right-2 top-1/2 z-[5] -translate-y-1/2 cursor-pointer text-[40px] text-[#FFF] pointer-events-auto smj:right-1 smj:text-[32px]",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    nextPhotos();
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "absolute bottom-4 left-1/2 z-[5] flex w-[min(360px,calc(100%-32px))] -translate-x-1/2 items-center gap-3 rounded-[24px] bg-[rgba(0,0,0,0.55)] px-4 py-2 pointer-events-auto",
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                        className: "shrink-0 text-[24px] text-[#FFF] ".concat(photoZoom <= MIN_PHOTO_ZOOM ? "cursor-not-allowed opacity-40" : "cursor-pointer"),
                                        onClick: zoomOutPhoto
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        className: "photo-preview-zoom-slider mx-1 min-w-0 flex-1",
                                        min: Math.round(MIN_PHOTO_ZOOM * 100),
                                        max: Math.round(MAX_PHOTO_ZOOM * 100),
                                        step: 5,
                                        value: Math.round(photoZoom * 100),
                                        tooltip: {
                                            formatter: (value)=>"".concat(value, "%")
                                        },
                                        onChange: onPhotoZoomSliderChange,
                                        styles: {
                                            rail: {
                                                backgroundColor: "rgba(255,255,255,0.25)"
                                            },
                                            track: {
                                                backgroundColor: "#FFCF55"
                                            },
                                            handle: {
                                                borderColor: "#FFCF55",
                                                backgroundColor: "#FFF"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                        className: "w-[44px] shrink-0 text-center text-[13px] text-white",
                                        children: [
                                            Math.round(photoZoom * 100),
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        className: "shrink-0 text-[24px] text-[#FFF] ".concat(photoZoom >= MAX_PHOTO_ZOOM ? "cursor-not-allowed opacity-40" : "cursor-pointer"),
                                        onClick: zoomInPhoto
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                ref: photoStageRef,
                                className: "absolute inset-0 z-[1] overflow-hidden pointer-events-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "flex h-full w-full items-center justify-center px-12 pb-20 pt-10 pointer-events-none smj:px-10 smj:pb-16 smj:pt-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        ref: photoPreviewRef,
                                        src: getCosUrl(photodata.url),
                                        alt: "img",
                                        draggable: false,
                                        className: "pointer-events-auto max-h-full max-w-full select-none object-contain ".concat(photoZoom > 1 ? "cursor-grab active:cursor-grabbing" : "cursor-zoom-out"),
                                        style: {
                                            WebkitUserDrag: "none",
                                            userSelect: "none",
                                            transform: "translate(".concat(panOffset.x, "px, ").concat(panOffset.y, "px) scale(").concat(photoZoom, ")"),
                                            transformOrigin: "center center",
                                            transition: isPhotoDragging ? "none" : "transform 120ms ease-out"
                                        },
                                        onDragStart: (e)=>e.preventDefault(),
                                        onLoad: ()=>{
                                            setPanOffset((prev)=>clampPanOffset(prev, photoZoomRef.current));
                                        },
                                        onPointerDown: onPhotoPointerDown,
                                        onPointerMove: onPhotoPointerMove,
                                        onPointerUp: onPhotoPointerUp,
                                        onPointerCancel: onPhotoPointerUp,
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            if (photoZoom <= 1) handleClose();
                                        }
                                    }, photodata.id || photodata.url)
                                })
                            })
                        ]
                    }),
                    videoModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        transition: {
                            duration: 0.2
                        },
                        className: "absolute w-full h-full bg-[rgba(0,0,0,0.5)] flex justify-center items-center flex-col",
                        onClick: ()=>{
                            cancelVideoModalOpen();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                            controls: true,
                            autoPlay: true,
                            id: "video",
                            preload: "auto",
                            loop: false,
                            muted: false,
                            className: "max-w-[80%] max-h-[80%]",
                            src: getCosUrl(currentVideo.original_url),
                            onClick: (e)=>e.stopPropagation()
                        })
                    })
                ]
            }) : null
        ]
    });
}


/***/ }),

/***/ 15171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4340);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15378);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);




const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
const RangePickerBox = (param)=>{
    let { className , rangePickerClassName , onClear , ...props } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative max-w-[400px] " + (className || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                placeholder: [
                    t("Start date"),
                    t("End date")
                ],
                allowClear: false,
                picker: "date",
                inputReadOnly: true,
                format: "YYYY-MM-DD",
                className: "h-[40px] text-[16px] w-full max-w-[400px] " + (rangePickerClassName || ""),
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "text-[#D9D9D9] absolute z-[1] translate-y-[-50%] right-[36px] top-[50%] cursor-pointer hover:text-[#bfbfbf]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onClear === null || onClear === void 0 ? void 0 : onClear(e);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RangePickerBox);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

}]);